<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 mb-4 mx-auto">
            <form @submit.prevent="onSubmit">
              <h4>{{ $t("pages.documentType.title_2") }}</h4>
              <hr />
              <div class="row mt-2">
                <div class="col">
                  <label>{{ $t("pages.documentType.designation") }} </label>
                  <input
                    type="text"
                    v-model.trim="documentType.name"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col">
                  <label>{{ $t("pages.documentType.description") }} </label>
                  <input
                    class="form-control"
                    v-model="documentType.description"
                    rows="2"
                    required
                  />
                </div>
              </div>
              <div class="row mt-4">
                <div class="col-12">
                  <label>{{ $t("pages.documentType.metadata") }} </label>
                  <a
                    href="#"
                    @click="showModal = true"
                    class="float-right text-success"
                  >
                    + {{ $t("pages.documentType.new_metadata") }}
                  </a>
                  <multiselect
                    v-model="forms.metadatas"
                    :options="forms.metadata"
                    :multiple="true"
                    tage-placeholder="Add this a new tag"
                    placeholder="Search or add tag"
                    label="label"
                    track-by="id"
                    :taggable="true"
                    @tag="addTag"
                  ></multiselect>
                </div>
                <div class="col-2">
                  <b-modal
                    id="modal-lg"
                    v-model="showModal"
                    size="lg"
                    :title="$t('pages.metadata.add')"
                    title-class="font-18"
                    hide-footer
                  >
                    <form @submit.prevent="addMetadata">
                      <div class="row">
                        <div class="col">
                          <label>{{
                            $t("pages.documentType.heading")
                          }}</label>
                          <input
                            type="text"
                            v-model.trim="forms.metadatas.label"
                            class="form-control"
                            required
                          />
                        </div>
                      </div>
                      <div class="row mt-4 mb-12">
                        <div class="col">
                          <label
                            >{{ $t("pages.documentType.type") }}
                          </label>
                          <select
                            class="form-control"
                            v-model.trim="forms.metadatas.type"
                          >
                            <option
                              v-for="(type, index) in types"
                              :key="index"
                              :value="type.value"
                            >
                              {{ $t(`pages.metadata.types.${type.type}`) }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="custom-control custom-switch mt-4">
                        <div class="col mt-3 text-left">
                          <input
                            type="checkbox"
                            v-model="forms.metadatas.required"
                            class="custom-control-input"
                            id="customSwitch1"
                          />
                          <label
                            class="custom-control-label"
                            for="customSwitch1"
                            >{{ $t("pages.documentType.required") }}</label
                          >
                        </div>
                      </div>
                      <hr />
                      <div class="row">
                        <div class="col">
                          <button
                            type="button"
                            class="btn btn-outline-light btn-block"
                            @click="closeModal"
                            data-dismiss="modal"
                          >
                            {{ $t("pages.documentType.cancel") }}
                          </button>
                        </div>
                        <div class="col">
                          <button
                            type="submit"
                            v-if="this.isLoading === false"
                            class="btn btn-primary btn-block"
                          >
                            {{ $t("pages.documentType.save") }}
                          </button>
                          <button
                            class="btn btn-primary btn-block"
                            type="button"
                            v-else
                            disabled
                          >
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            {{ $t("pages.documentType.saving") }}
                          </button>
                        </div>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
              <br />
              <div class="mt-4 mb-2">
                <div class="row">
                  <div class="col-md-12">
                    <button
                      v-if="this.isLoading === false"
                      type="submit"
                      class="btn btn-primary"
                    >
                      {{ $t("pages.documentType.save") }}
                    </button>
                    <button
                      class="btn btn-primary"
                      type="button"
                      v-else
                      disabled
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {{ $t("pages.documentType.saving") }}
                    </button>
                    <router-link
                      :to="{ name: 'DocumentTypes' }"
                      class="btn btn-light ml-2"
                    >
                      {{ $t("pages.documentType.cancel") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions  } from "vuex";

export default {
  page: {
    title: "Documents Types",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Multiselect,
  },

  data() {
    return {
      title: "pages.documentType.typeDocument",
      items: [
        {
          text: "menuitems.dashboards.text",
        },
        {
          text: "document-types",
        },
        {
          text: "pages.documentType.edit",
          active: true,
        },
      ],
      types: [
        {
          type: "number",
          value: "number",
          text: this.$t("pages.metadata.types.number"),
        },
        {
          type: "string",
          value: "string",
          text: this.$t("pages.metadata.types.string"),
        },
        {
          type: "text",
          value: "text",
          text: this.$t("pages.metadata.types.text"),
        },
        {
          type: "date",
          value: "date",
          text: this.$t("pages.metadata.types.date"),
        },
        {
          type: "boolean",
          value: "boolean",
          text: this.$t("pages.metadata.types.boolean"),
        },
        {
          type: "list",
          value: "list",
          text: this.$t("pages.metadata.types.list"),
        },
        {
          type: "file",
          value: "file",
          text: this.$t("pages.metadata.types.file"),
        },
      ],

      forms: {
        metadatas: [],
        name: "",
        description: "",
        metadata: [],
      },
      isLoading: false,
      msgErr: "",
      isChecked: false,
      showModal: false,
    };
  },

  methods: {
    ...mapActions([
      "updateDocumentType",
      "getDocumentTypeMetadas",
      "getMetadata",
      "createMetadata",
    ]),
    onSubmit() {
      if (this.$can("update", "document-types")) {
        this.isLoading = true;
        var documentTypeUpdate = new FormData();

        documentTypeUpdate.append("name", this.documentType.name);
        documentTypeUpdate.append("description", this.documentType.description);
        documentTypeUpdate.append(
          "metadata",
          JSON.stringify(this.forms.metadatas)
        );

        let data = {
          id: this.$route.params.id,
          documentType: documentTypeUpdate,
        };
        this.$store.dispatch('updateDocumentType', data )
          .then((response) => {
            if (response.status == 200) {
              this.$toasted.success("le type de document modifié avec succès", {
                duration: 3000,
                position: "top-center",
              });
              this.isLoading = false;
              this.$router.push({ name: "DocumentTypes" });
            }
          })
          .catch(() => {
            this.isLoading = false;
            this.$toasted.error("Une erreur est survenue", {
              duration: 3000,
              position: "top-center",
            });
          });
      } else {
        this.isLoading = false;
        this.$toasted.error(
          "Vous n'etes pas autorisé à effectuer cette action",
          {
            duration: 4000,
            position: "top-center",
          }
        );
      }
    },
    addMetadata() {
      let formData = new FormData();
      formData.append("label", this.forms.metadatas.label);
      formData.append("type", this.forms.metadatas.type);
      formData.append("required", this.forms.metadatas.required);
      this.createMetadata(formData)
        .then((response) => {
          if (response.status === 201) {
            this.isLoading = false;
            this.$toasted.success("Ajout effectué avec succès");
            this.closeModal();

            this.getDocumentTypeMetadas(this.$route.params.id)
              .then((response) => {
                if (response.status == 200) {
                  this.isLoading = false;
                  this.forms.metadatas = response.data.Metadata;
                } else {
                  this.isLoading = false;
                }
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.isLoading = false;
            this.$toasted.error("Ce nom existe déjà", {
              duration: 3000,
              position: "top-center",
            });
          } else {
            this.isLoading = false;
            this.$toasted.error(
              "Une erreur est survenue, Veuillez réessayer SVP...",
              {
                duration: 3000,
                position: "top-center",
              }
            );
          }
        });
    },
    addTag(newTag) {
      const tag = {
        label: newTag,
        type: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.forms.metadata.push(tag);
      this.forms.metadatas.push(tag);
    },
    closeModal() {
      this.showModal = false;
      this.forms.metadatas = {
        label: "",
        type: "",
        required: false,
      };
    },
  },

  computed: {
    documentType() {
      return {...this.$store.state.documentType.documentType}
    }
  },

  created() {
    if (this.$can("update", "document-types")) {
      this.getDocumentTypeMetadas(this.$route.params.id)
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
            this.forms.metadatas = response.data.Metadata;
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });

      this.getMetadata()
        .then((response) => {
          if (response.status == 200) {
            this.isLoading = false;
            this.forms.metadata = response.data;
          } else {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  },
};
</script>

<style>
</style>